module.exports = __webpack_public_path__ + "img/gb-whatsapp.fde0b1f2.webp";